export const UnhandledException = "Unhandled Exception. Please inform developers team about it";
